import { render, staticRenderFns } from "./ConfigInfo.vue?vue&type=template&id=51e2b154&functional=true"
import script from "./ConfigInfo.vue?vue&type=script&lang=js"
export * from "./ConfigInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports